const sha256 = value => typeof value === 'string' && /^[a-f0-9]{64}$/.test(value);
const count = value => Number.isSafeInteger(value) && value >= 0;
export const matchingEvidenceSource = (report, evidence) => Boolean(
  evidence && sha256(report?.file?.sha256) && evidence.sourceSha256 === report.file.sha256
  && typeof report?.sourceGeneration === 'string' && /^[1-9]\d*$/.test(report.sourceGeneration)
  && evidence.sourceGeneration === report.sourceGeneration
);
const safeText = (value, maximum = 240) => typeof value === 'string' && value.trim() && value.length <= maximum ? value : null;
const modelAmount = value => typeof value === 'string' && /^-?\d+$/.test(value) && value.length <= 17 && Number.isSafeInteger(Number(value)) ? value : null;
const modelDate = value => {
  if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return null;
  const parsed = new Date(`${value}T00:00:00Z`);
  return Number.isFinite(parsed.getTime()) && parsed.toISOString().slice(0, 10) === value ? value : null;
};

export function preliminaryCandidates(report) {
  const artifact = report?.dlocalCandidates;
  if (!artifact) return null;
  if (artifact.contract !== 'dlocal-preliminary-candidates-v1'
    || artifact.evidenceStatus !== 'preliminary_unreviewed'
    || artifact.normalization !== 'legacy_base_units_rounded_with_possible_assumed_dates'
    || !matchingEvidenceSource(report, artifact)
    || !['tenantId', 'companyId'].every(key => safeText(report[key]) && artifact[key] === report[key])
    || !safeText(report.id) || artifact.reportId !== report.id
    || !Array.isArray(artifact.rows) || artifact.rows.length > 500
    || artifact.rows.some(row => !safeText(row?.id) || !safeText(row.sourceKey)
      || !['unverified', 'source_matched_unreviewed'].includes(row.status))
    || new Set(artifact.rows.map(row => row.id)).size !== artifact.rows.length) return { unavailable: true };
  return { rows: artifact.rows.map(row => ({
    id: row.id, label: row.sourceKey, amount: modelAmount(row.modelAmount),
    currency: typeof row.modelCurrency === 'string' && /^[A-Z]{3}$/.test(row.modelCurrency) ? row.modelCurrency : null,
    date: modelDate(row.modelDate),
  })) };
}

export function ocrEvidenceProgress(report) {
  const progress = report?.ocrProgress;
  const evidence = progress || report?.ocrEvidence;
  if (!evidence) return null;
  if (!matchingEvidenceSource(report, evidence)
    || ![evidence.completedPages, evidence.totalPages, evidence.requestedPages].every(count)
    || evidence.completedPages > evidence.requestedPages || evidence.requestedPages > evidence.totalPages) return { unavailable: true };
  if (progress) {
    const stages = ['processing', 'completed', 'completed_with_unavailable', 'failed'];
    if (progress.phase !== 'ocr' || !stages.includes(progress.stage) || !Array.isArray(progress.pages)
      || progress.pages.length !== progress.requestedPages
      || progress.pages.some(page => !Number.isSafeInteger(page?.page) || page.page < 1 || page.page > progress.totalPages
        || !['recognized', 'unavailable', 'pending'].includes(page.status))
      || new Set(progress.pages.map(page => page.page)).size !== progress.pages.length
      || progress.pages.filter(page => page.status === 'recognized').length !== progress.completedPages
      || (progress.stage === 'completed' && progress.completedPages !== progress.requestedPages)
      || (progress.stage === 'completed_with_unavailable' && (progress.pages.some(page => page.status === 'pending') || progress.completedPages === progress.requestedPages))) return { unavailable: true };
  } else if (evidence.version !== 1 || evidence.origin !== 'ocr' || !sha256(evidence.artifactSha256)) return { unavailable: true };
  return { completed: evidence.completedPages, requested: evidence.requestedPages, total: evidence.totalPages,
    stage: progress?.stage || (evidence.completedPages === evidence.requestedPages ? 'completed' : 'completed_with_unavailable'),
    pages: progress?.pages || null };
}
